<template>
  <div>
    <Header />
    <main>
      <Masonry :title="scrapbookName"/>
    </main>
  </div>
</template>

<script>
import Header from "@/components/layout/Header.vue";
import store from '@/store'
import Masonry from "@/components/components/Masonry.vue";

export default {
  name: "scrapbook",
  components: {
    Header,
    Masonry
  },
  computed: {
    scrapbookName () {
      if (store.state.scrapbooks.byScrapbook[this.$route.params.id] && store.state.scrapbooks.byScrapbook[this.$route.params.id].meta.name) {
        return store.state.scrapbooks.byScrapbook[this.$route.params.id].meta.name
      }
      return ''
    }
  },
  beforeCreate () {
    console.log( this.$route.params.id )
    if (this.$route.params.id) {
      store.dispatch('setActiveScrapbook', this.$route.params.id)
    }
  }

}
</script>

<style scoped>
  h1 {
    margin: 0 auto;
    text-align: center;
  }
</style>
